<template>
  <div v-loading="loading">
    <el-table
      :data="docVersions"
      style="width: 100%"
    >
      <el-table-column
        label="Fájl"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            @click="downloadFile(scope.row)"
          >
            <i class="el-icon-download"></i> {{ scope.row.version }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        label="Létrehozva"
      >
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTime }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <Actions :doc-version="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';

  export default {
    components: {
      Actions,
    },
    data() {
      return {
      };
    },
    computed: {
      docVersions() {
        return this.$store.getters['docVersion/docVersions'];
      },
      loading() {
        return this.$store.getters['docVersion/loading'];
      },
    },
    methods: {
      downloadFile(row) {
        window.open(row.file.path);
      },
    },
    async mounted() {
      await this.$store.dispatch('docVersion/fetchAll');
    },
  };
</script>

